module.exports = __webpack_public_path__ + "public/img/08.9008243d.png";